import React from "react";
import { Box } from "@mui/material";
import "./GroupTable.css";
import DeleteIcon from "@mui/icons-material/Delete";
import UndoIcon from "@mui/icons-material/Undo";

const GroupTable = ({ currentRows = [], page = 1, rowsPerPage = 10,
  onDelete,
  onUndo, }) => {
  const safePage = Number.isFinite(Number(page)) ? Number(page) : 1;
  const safeRowsPerPage = Number.isFinite(Number(rowsPerPage)) ? Number(rowsPerPage) : 10;

  return (
    <Box sx={{ mt: 2 }}>
      <table
        className="pd-table"
        style={{
          width: "100%",
          tableLayout: "auto",
          borderCollapse: "collapse"
        }}
      >
        <thead>
          <tr>
            <th style={{ width: "80px" }}>S.No</th>
            <th style={{ width: "200px" }}>Employee Name</th>
            <th style={{ width: "150px" }}>Group Name</th>
            <th style={{ width: "80px" }}>Action</th>
          </tr>
        </thead>
        <tbody>
          {currentRows.length > 0 ? (
            currentRows.map((emp, index) => (
              <tr
                key={emp.id || index}
                style={{
                  opacity: emp.isActive !== false ? 1 : 0.5,
                  backgroundColor: emp.isActive !== false ? "inherit" : "#f5f5f5"
                }}
              >
                <td>{(safePage - 1) * safeRowsPerPage + index + 1}</td>
                <td
                  style={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                  }}
                >
                  {emp.fullName || emp.employeeName || "N/A"}
                </td>
                <td>{emp.groupName || "Unknown Group"}</td>
                <td>
                  {emp.isActive !== false ? (
                    <button
                      className="action-icon"
                      onClick={() => onDelete(emp.id || emp.ssoUserId)}
                      title="Delete"
                    >
                      <DeleteIcon fontSize="small" />
                    </button>
                  ) : (
                    <button
                      className="action-icon"
                      onClick={() => onUndo(emp.id || emp.ssoUserId)}
                      title="Undo"
                    >
                      <UndoIcon fontSize="small" />
                    </button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" align="center">
                No employees in selected groups.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </Box>
  );
};

export default GroupTable;
